import React from 'react';
import { Bookmark, BookmarkCheck } from 'lucide-react';
import { Button } from './ui/button';
import { useBookmarks } from '../contexts/BookmarksContext';
import { useToast } from '../hooks/use-toast';

const BookmarkButton = ({ post, variant = 'icon', className = '' }) => {
  const { isBookmarked, toggleBookmark } = useBookmarks();
  const { toast } = useToast();
  const bookmarked = isBookmarked(post.id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleBookmark(post);
    
    toast({
      title: bookmarked ? 'Bookmark removed' : 'Article bookmarked!',
      description: bookmarked 
        ? 'Removed from your saved articles' 
        : 'You can find it in your bookmarks',
      duration: 2000
    });
  };

  if (variant === 'icon') {
    return (
      <Button
        variant="ghost"
        size="icon"
        onClick={handleClick}
        className={`h-9 w-9 ${bookmarked ? 'text-orange-400' : 'text-gray-400 hover:text-orange-400'} ${className}`}
        data-testid={`bookmark-btn-${post.id}`}
        aria-label={bookmarked ? 'Remove bookmark' : 'Bookmark article'}
      >
        {bookmarked ? (
          <BookmarkCheck className="h-5 w-5 fill-current" />
        ) : (
          <Bookmark className="h-5 w-5" />
        )}
      </Button>
    );
  }

  return (
    <Button
      variant={bookmarked ? 'default' : 'outline'}
      onClick={handleClick}
      className={`${bookmarked ? 'bg-orange-500 hover:bg-orange-600' : 'border-gray-700 hover:border-orange-500'} ${className}`}
      data-testid={`bookmark-btn-${post.id}`}
    >
      {bookmarked ? (
        <>
          <BookmarkCheck className="h-4 w-4 mr-2 fill-current" />
          Saved
        </>
      ) : (
        <>
          <Bookmark className="h-4 w-4 mr-2" />
          Save for Later
        </>
      )}
    </Button>
  );
};

export default BookmarkButton;
